import { useCallback } from 'react';
import KubernetesAppName from '~/constants/common/KubernetesAppName';
import BrowserCookies from '~/utilities/BrowserCookies';
import {
  getBranchCookieName,
  getEnabledCookieName
} from '~/utilities/featureBranch';

export default function useSetFeatureBranch(
  kubernetesAppName: KubernetesAppName,
  setErrorMessage: (errorMessage: string) => void
): (branchName: string, setForAllApps?: boolean) => boolean {
  return useCallback(
    (branchName: string, setForAllApps = false): boolean => {
      if (!branchName) {
        return false;
      }

      const featureBranchName = branchName
        .toLowerCase()
        .match(/reo-[0-9a-z-]*/)?.[0];

      if (featureBranchName) {
        const appNames = setForAllApps
          ? Object.values(KubernetesAppName)
          : [kubernetesAppName];

        appNames.forEach(appName => {
          BrowserCookies.set(getEnabledCookieName(appName), 'true');
          BrowserCookies.set(
            getBranchCookieName(appName),
            `carvana-merch-merchui-${featureBranchName}`
          );
        });

        return true;
      } else {
        setErrorMessage(
          `Could not parse a feature branch name from ${branchName}.`
        );

        return false;
      }
    },
    [kubernetesAppName, setErrorMessage]
  );
}
